export default "__VITE_ASSET__CImMiMRF__"